import {
  InputTextProps,
  InputTextComponentInnerProps,
  InputTextStyledComponentProps,
  InputTextTypes,
} from "./types"
import React from "react"
import { TextInput } from "~/ui/primitives"
import { InputTextCore } from "./core"
import { FeildFloatLabel } from "~widgets/feild-float-label"
import styled from '~/ui/styled'

const StyledTextInput = styled(TextInput)<InputTextStyledComponentProps>`
  padding: ${({ theme }) => theme.space.sm};
  border-radius: ${({ theme }) => theme.radii.sm};
  border-width: 1px;
  border-color: ${({ error, isFocus, theme }) => {
    if (error) {return theme.colors.danger}
    else if (isFocus) {return theme.colors.primary}
    else {return "transparent"}
  }};
  color: ${({ theme }) => theme.colors.text};
  background-color: "white";
`

export const InputTextFloatLabelInnerUnrefed: React.ForwardRefRenderFunction<
  TextInput,
  InputTextComponentInnerProps
> = ({ label, ...rest }, ref) => {
  return (
    <>
      {!!label && <FeildFloatLabel>{label}</FeildFloatLabel>}
      <StyledTextInput {...rest} ref={ref} />
    </>
  )
}

const InputTextNoBorderLabel: React.ForwardRefRenderFunction<TextInput, InputTextProps> = (
  { label, validRule, ...rest },
  ref,
) => {
  return (
    <InputTextCore
      {...rest}
      label={label}
      validRule={validRule}
      type={InputTextTypes.INPUT_TEXT_FLOAT_LABEL}
      ref={ref}
    ></InputTextCore>
  )
}

export default React.forwardRef(InputTextNoBorderLabel)
